import type { LegacySubscription } from '../../types';

import { hasPlan } from './hasPlan';

export function isInvoiced(legacySubscription: LegacySubscription) {
  return !legacySubscription.periodEndDate && hasPlan(legacySubscription);
}
